export const SidebarPositions = {
  Left: 'left',
  Right: 'right',
} as const
export type SidebarPositions =
  (typeof SidebarPositions)[keyof typeof SidebarPositions]
